import React from 'react';

export const DiamondLogo = ({ size = 80, className = '' }) => {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="diamond-logo"
    >
      {/* Outer diamond (rotated square = baseball diamond) */}
      <g transform="translate(60, 60) rotate(45)">
        <rect x="-42" y="-42" width="84" height="84" rx="6" fill="white" />
        <rect x="-38" y="-38" width="76" height="76" rx="4" fill="#14532d" />
      </g>

      {/* Base paths - thin white lines forming the diamond infield */}
      <line x1="60" y1="18" x2="102" y2="60" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <line x1="102" y1="60" x2="60" y2="102" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <line x1="60" y1="102" x2="18" y2="60" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
      <line x1="18" y1="60" x2="60" y2="18" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />

      {/* Base dots */}
      <circle cx="60" cy="18" r="3" fill="rgba(255,255,255,0.3)" /> {/* 2nd base */}
      <circle cx="102" cy="60" r="3" fill="rgba(255,255,255,0.3)" /> {/* 1st base */}
      <circle cx="18" cy="60" r="3" fill="rgba(255,255,255,0.3)" /> {/* 3rd base */}

      {/* Home plate at bottom */}
      <polygon points="60,97 55,102 60,107 65,102" fill="white" opacity="0.9" />

      {/* DS Text - bold, athletic */}
      <text
        x="60"
        y="68"
        textAnchor="middle"
        fill="white"
        fontFamily="'Barlow Condensed', sans-serif"
        fontWeight="800"
        fontSize="40"
        letterSpacing="-1"
      >
        DS
      </text>

      {/* Subtle baseball stitch arc at top */}
      <path
        d="M 42 28 Q 51 22 60 28 Q 69 22 78 28"
        stroke="rgba(255,255,255,0.25)"
        strokeWidth="1.2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DiamondLogoSmall = ({ size = 36, className = '' }) => {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="diamond-logo-small"
    >
      {/* Outer diamond */}
      <g transform="translate(60, 60) rotate(45)">
        <rect x="-42" y="-42" width="84" height="84" rx="6" fill="white" />
        <rect x="-38" y="-38" width="76" height="76" rx="4" fill="#14532d" />
      </g>

      {/* Home plate at bottom */}
      <polygon points="60,97 55,102 60,107 65,102" fill="white" opacity="0.9" />

      {/* DS Text */}
      <text
        x="60"
        y="68"
        textAnchor="middle"
        fill="white"
        fontFamily="'Barlow Condensed', sans-serif"
        fontWeight="800"
        fontSize="40"
        letterSpacing="-1"
      >
        DS
      </text>
    </svg>
  );
};
